<template>

<div class="col-md-12 grid-margin stretch-card">
			<div class="card activeCard">
			<div class="card-body forceLTR">
				<div v-if="isUsePatientInfo" class="d-flex align-items-start justify-content-between pointer forceLTR">
				<h6 v-on:click="GoToPatientInfo" class="card-title flex-grow lower-line text-truncate">{{ $t('Shared.PatientInfo') }}</h6>
				<i class="mdi mdi-arrow-right-drop-circle text-corporate" v-on:click="GoToPatientInfo" ></i>
				<b-button  v-on:click="DoReport()"  style="position: relative; top: -4px;" class="repDateNotesBtn mx-2"  v-b-tooltip.hover :title="$t('MdPatientInfoBox.CurrentFaceSheet')">
					{{ $t('Shared.FS') }}
				</b-button>
				<!--<i class="ikon med-report text-corporate mr-2" v-b-tooltip.hover title="Admission Face Sheet" style="scale:1.3; position: relative; top: 2px;" v-on:click="DoReport()" ></i>-->
				
			</div>
			<div v-if="!isUsePatientInfo" class="d-flex align-items-start justify-content-between">
				<h6 class="card-title flex-grow lower-line text-truncate">{{ $t('Shared.PatientInfo') }}</h6>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.patientCode">
				<small>{{ $t('Shared.PatientCode') }}</small><br>
				<b>{{this.PatientInfo.patientCode}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.firstName && this.PatientInfo.lastName">
				<small>{{ $t('Shared.PatientName') }}</small><br>
				<b>{{this.PatientInfo.firstName +" "+this.PatientInfo.lastName}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.dob">
				<small>{{ $t('Shared.Dob') }}</small><br>
				<b>{{this.PatientInfo.dob}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="!ShowPortalStatus && this.PatientInfo.gender">
				<small>{{ $t('Shared.Gender') }}</small><br>
				<b>{{this.PatientInfo.gender}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="!ShowPortalStatus && this.PatientInfo.primaryInsurance">
				<small>{{ $t('Shared.PrimaryInsurance') }}</small><br>
				<b>{{this.PatientInfo.primaryInsurance}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="!ShowPortalStatus && this.PatientInfo.attendingDoctor">
				<small>{{ $t('Shared.AttendingDoctor') }}</small><br>
				<b>{{this.PatientInfo.attendingDoctor}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.cellPhone">
				<small>{{ $t('Shared.CellPhone') }}</small><br>
				<b><a :href="'tel:'+this.PatientInfo.cellPhone" class="dashLink dashCell">{{this.PatientInfo.cellPhone}}</a></b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.email">
				<small>{{ $t('Shared.Email') }}</small><br>
				<b><a :href="'mailto:'+this.PatientInfo.email" class="dashLink dashMail">{{this.PatientInfo.email}}</a></b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.patientAddress">
				<small>{{ $t('Shared.PatientAddress') }} </small><br>
				<b>{{this.PatientInfo.patientAddress}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="this.PatientInfo.serviceLocation">
				<small>{{ $t('Patient.ServiceLocation') }} </small><br>
				<b>{{this.PatientInfo.serviceLocation}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="ShowPortalStatus && this.PatientInfo.portalStatus">
				<small>{{ $t('Shared.PortalStatus') }}</small><br>
				<b :class="{ 'DocumentExpired': this.PatientInfo.portalStatus === 'Enrolled' }">{{this.PatientInfo.portalStatusTranslated}}</b>
			</div>
			<div class="float-left col-md-4 text-muted p-item" v-if="ShowPortalStatus && this.PatientInfo.portalUserName">
				<small>{{ $t('PatientPortalDashboard.PortalUserName') }}</small><br>
				<b>{{this.PatientInfo.portalUserName}}</b>
			</div>
			</div>
		</div>
		<DxPopup 
			:visible="isReportPatientFaceSheetVisible"
			:drag-enabled="true"
			:close-on-outside-click="false"
			:show-close-button="true"
			:show-title="true"
			:hide-on-parent-scroll="true"
			:title="reportTitle"
			@hidden="onHiddenReport"
			:resize-enabled="true"
			shading-color="rgba(0, 0, 0, 0.5)"
			height="94vh"
			width="97vw"
			@showing="onShowing"
		>
			<ReportViewer
			ref="PatientFaceSheetRep"
			:ReportName="'PatientFaceSheet'"
			:ReportTitle="reportTitle"
			:IsAnAPIReport="true"
			/>
		</DxPopup>
	</div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import { DxPopup } from 'devextreme-vue/popup';
  export default {
    props: {
	PatientCode: String,
	ShowPortalStatus: {
		type: Boolean,
		default: false
	}
   },
    mixins: [DBFunctions],
	components: { DxPopup },
    data() {
      return {
		PatientInfo:{},
		isUsePatientInfo: this.$store.state.isUsePatientInfo,
		isReportPatientFaceSheetVisible: false,
		reportTitle: this.$t('MdPatientInfoBox.PatientFaceSheet'),
      }
    },
    
  methods:{
	
	onShowing(e) {
		let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
    },

	onHiddenReport() {
		this.isReportPatientFaceSheetVisible = false
    },

	DoReport() {
		this.reportParams = []

        this.reportParams.push({ paramName: 'PatientCodeList', paramValue: this.PatientInfo.patientCode})
		this.reportParams.push({ paramName: 'ActivePatient', paramValue: ''})
        this.reportParams.push({ paramName: 'ActiveAdmission', paramValue: ''})
        
        this.isReportPatientFaceSheetVisible = true
        this.$refs.PatientFaceSheetRep.buildDocument(this.reportParams)
	},

	async getPatientInfo(){
		this.PatientInfo = await this.getData(this.PatientCode);
	},

    GoToPatientInfo(){
		if(this.$route.name.includes('patients-portal')){
			this.$router.push({ name: "patients-portal-info", params: { id: this.$route.params.id } }).catch(()=>{});
		}
		else if(this.$route.name.includes('Clinical')){
			this.$router.push({ name: "Clinical-PatientInfo", params: { id: this.$route.params.id,recordid:this.$route.params.recordid } }).catch(()=>{});
		}
		else if(this.$route.name.includes('appointmentDB-Dashboard')){
			this.$router.push({ name: "appointmentDB-PatientInfo", params: { id: this.$route.params.id,actId:this.$route.params.actId } }).catch(()=>{});
		}
		else if(this.$route.name.includes('patient')){
			this.$router.push({ name: "patient-details", params: { id: this.$route.params.id } }).catch(()=>{});
		}

    },
  },
  mounted() {
	this.getPatientInfo();
  }
}

</script>
